import { shallowEqual } from 'react-redux';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { RootReducer } from 'redux/reducers';
import { zoomSetAroundCanvasCenter } from 'redux/mode/actions';
import DropdownMenu from 'components/Widget/DropdownMenu';
import Icon, { IconType } from 'components/Icon';
import * as S from './styles';
import { MenuItemAction, MenuItemDivider } from 'menu/MenuItem';
import store from 'redux/store';
import { selectTransform } from 'redux/mode/reducers';

const ZoomMenuButton = () => {
	const theme = useTheme();

	const { scale } = useSelector((r: RootReducer) => {
		return {
			scale: selectTransform(r.mode).scale,
		};
	}, shallowEqual);

	const menuItems = [
		MenuItemAction.createZoomIn(),
		MenuItemAction.createZoomOut(),
		new MenuItemDivider(),
		new MenuItemAction('Zoom to 25%', '', async () => {
			store.dispatch(zoomSetAroundCanvasCenter(0.25));
		}),
		new MenuItemAction('Zoom to 50%', '', async () => {
			store.dispatch(zoomSetAroundCanvasCenter(0.5));
		}),
		MenuItemAction.createZoomReset(),
		new MenuItemAction('Zoom to 200%', '', async () => {
			store.dispatch(zoomSetAroundCanvasCenter(2.0));
		}),
		new MenuItemDivider(),
		MenuItemAction.createZoomToFitCanvas(),
		MenuItemAction.createZoomToFitSelection(),
	];
	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base>
			<DropdownMenu menuItems={menuItems}>
				<S.InnerWrapper>
					<S.ZoomWrapper>
						<S.ZoomAmount>{Math.round(scale * 100)}%</S.ZoomAmount>
					</S.ZoomWrapper>
					<S.DownArrow>
						<Icon
							type={IconType.FILLED_ARROW_DOWN}
							width={10}
							height={24}
							color={theme.gray[1000]}
						/>
					</S.DownArrow>
				</S.InnerWrapper>
			</DropdownMenu>
		</S.Base>
	);
};

export default ZoomMenuButton;
